import { Pipe, PipeTransform } from '@angular/core';

import { IdentifierUtils } from '../../core';
import { OtherArticleIdentifierDto } from '@scip/api';

@Pipe({
  name: 'otherArticleIdentifier'
})
export class OtherArticleIdentifierPipe implements PipeTransform {
  transform(otherArticleIdentifiers: OtherArticleIdentifierDto[]): any[] {
    const keyValues: any[] = [];
    if (otherArticleIdentifiers && otherArticleIdentifiers.length > 0) {
      for (const identifier of otherArticleIdentifiers) {
        keyValues.push({ textKey: IdentifierUtils.abbreviateOtherArticleIdentifier(identifier.pickListData.identifier), value: identifier.value });
      }
    }
    return keyValues;
  }
}
